import { Chip } from '@mui/material'
import { CompoundProductionStepDto, PreparationStatus } from '@services/dtos'
import {
  PreparationStatusColors,
  PreparationStatusLabels,
} from '@utils/constants'

interface Props {
  status: PreparationStatus
  steps?: CompoundProductionStepDto[]
  currentStepIndex?: number | null
}

export const ChipPreparationStatus = ({
  status,
  steps,
  currentStepIndex,
}: Props) => {
  const stepLabel =
    status === PreparationStatus.DRAFT && (steps?.length ?? 0) > 0
      ? `${Math.max((currentStepIndex ?? -1) + 1, 0)}/${steps?.length}`
      : undefined

  return (
    <Chip
      label={
        stepLabel
          ? `${PreparationStatusLabels[status]} (${stepLabel})`
          : PreparationStatusLabels[status]
      }
      size="small"
      variant={status === PreparationStatus.DRAFT ? 'outlined' : 'filled'}
      sx={PreparationStatusColors[status]}
    />
  )
}
